/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minor_These_Flea_SpinInputs */

const fr_minor_these_flea_spin = /** @type {(inputs: Minor_These_Flea_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si coché, alors le programme sera visible sur l'application.`)
};

/**

* @param {Minor_These_Flea_SpinInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const minor_these_flea_spin = /** @type {((inputs?: Minor_These_Flea_SpinInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minor_These_Flea_SpinInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_minor_these_flea_spin(inputs)
});